/**
 * Created by sy on 2018/9/18.
 */
/**
 * 关于axios拦截器说明，有证据表明存在内存泄漏问题，请慎用！！！
 */
import axios from "axios";
import qs from "qs";
import router from "../router";
import "@/assets/js/base.js";
import sendMessageToNative from "../mixins/index";
import Vue from "vue";
import { isQYWXTPI, replaceBy, getQueryString } from "@/lib/util";
import layer from "vue-layer";
// 消息通知全局配置
let layerMsg = layer(Vue, {
  msgtime: 3, // 消失时间
});

axios.defaults.baseURL =
  process.env.VUE_APP_MODE === "local" ? "/api" : window.location.origin;
axios.defaults.timeout = 10000;
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";

// axios请求是否携带cookie
// axios.defaults.withCredentials = true;
/* // 自定义请求拦截器
axios.interceptors.request.use(config, error => {
  return Promise.reject(error)
})

// 自定义响应拦截器
axios.interceptors.response.use(response => response, error => {
  return Promise.resolve(error.response)
}) */

function checkStatus(response) {
  if (localStorage.toWeixinMiddle !== 1) {
    return response;
  }
}

function checkCode(res) {
  let site = window.location.href;
  if (res.data.code === 10600 && site.indexOf("free_register") == -1) {
    // if (res.data.code === 10600) {
    // // 扫码免费体验课程 如果token失效
    // let site = window.location.href

    if (!sessionStorage.fromUrl) {
      sessionStorage.fromUrl = decodeURI(window.location.href).match(
        /#(\S*)/
      )[1];
    }
    // layerMsg.msg('身份验证失效，请重新登录')

    // app接入
    var webview = {};
    if (window.location.hash.includes("?")) {
      window.location.hash
        .split("?")[1]
        .split("&")
        .forEach((e) => {
          let arr0 = e.split("=")[0];
          let arr1 = e.split("=")[1];
          webview[arr0] = arr1;
        });
      if (webview.is_webview == 1) {
        var stringJson = {
          pageType: "login",
          // data: {
          //   expired: 1
          // }
        };
        sendMessageToNative.methods.sendMessageToNative(stringJson);
      }
    }

    // if(localStorage._user_data_id && localStorage._source_type) {
    let id = localStorage._user_data_id;
    if (id && localStorage[`_from_api_${id}`]) {
      router.replace({
        name: "error",
        query: {
          msg: "token已过期",
        },
      });
    } else {
      let toWeixinMiddle = parseInt(localStorage.toWeixinMiddle);
      let is_custom_app = parseInt(localStorage.is_custom_app);

      localStorage.clear();

      if (toWeixinMiddle === 1) {
        localStorage.setItem("toWeixinMiddle", 1);
        return;
      }
      if (is_custom_app === -1 || is_custom_app === 0 || is_custom_app === 1) {
        console.log("replaceBy1");
        replaceBy(router, is_custom_app);
      } else {
        isQYWXTPI().then((res) => {
          if (parseInt(res) > -2) {
            console.log("replaceBy2");
            replaceBy(router, parseInt(res));
          }
        });
      }
    }
  }
  if (res === undefined) {
    layerMsg.msg("客户机与服务器连接异常");
    return;
  }
  if (res.status === 401) {
    sessionStorage.removeItem("auth");
    layerMsg.msg("登录超时，请重新登录");
    router.push({
      name: "Login",
    });
  } else if (res.status === 403) {
    layerMsg.msg("您没有进行此操作的权限");
  } else if (res.status === 404) {
    layerMsg.msg("抱歉，这个页面已经被外星人绑架了！");
  } else if (res.status === 502) {
    layerMsg.msg("哎呀，服务器暂时无法通行，请稍后重试!");
  } else if (res.status !== 200) {
    layerMsg.msg(res.statusText);
  }
  return res;
}

export default {
  post(url, data) {
    if (localStorage._user_data_id) data.user_id = localStorage._user_data_id;
    if (localStorage._user_data_department_id)
      data.department_id = localStorage._user_data_department_id;
    if (localStorage._user_data_company_id)
      data.company_id = localStorage._user_data_company_id;
    if (localStorage._user_data_language) {
      data.language = localStorage._user_data_language;
      // data.language = 'en-US'
    }
    if (localStorage._user_data_sso_token) {
      data.sso_token = localStorage._user_data_sso_token;
      data.client_version = localStorage.client_version || "1.2.0";
      // data.sys_id = '5'
      data.sys_id = localStorage._sys_id || "5";
    }
    if (localStorage._sys_id) data.sys_id = localStorage._sys_id;

    const disable_drag = getQueryString("disable_drag");
    if (disable_drag !== null && disable_drag !== undefined) {
      data.disable_drag = disable_drag;
    }

    const show_speed_btn = getQueryString("show_speed_btn");
    if (show_speed_btn !== null && show_speed_btn !== undefined) {
      data.show_speed_btn = show_speed_btn;
    }

    const show_full_screen_btn = Vue.prototype.getQueryString(
      "show_full_screen_btn"
    );
    if (show_full_screen_btn !== null && show_full_screen_btn !== undefined) {
      data.show_full_screen_btn = show_full_screen_btn;
    }

    const fold_menu = Vue.prototype.getQueryString("fold_menu");
    if (fold_menu !== null && fold_menu !== undefined) {
      data.fold_menu = fold_menu;
    }

    const hidden_intro_outro =
      Vue.prototype.getQueryString("hidden_intro_outro");
    if (hidden_intro_outro !== null && hidden_intro_outro !== undefined) {
      data.hidden_intro_outro = hidden_intro_outro;
    }

    const video_stop_time = Vue.prototype.getQueryString("video_stop_time");
    if (video_stop_time !== null && video_stop_time !== undefined) {
      data.video_stop_time = video_stop_time;
    }

    return axios({
      method: "post",
      url: url,
      data: qs.stringify(data),
      // data: data,
      withCredentials: true,
    })
      .then(checkStatus)
      .then(checkCode);
  },
  get(url, params) {
    if (localStorage._user_data_id) params.user_id = localStorage._user_data_id;
    if (localStorage._user_data_department_id)
      params.department_id = localStorage._user_data_department_id;
    if (localStorage._user_data_company_id)
      params.company_id = localStorage._user_data_company_id;
    if (localStorage._user_data_language) {
      params.language = localStorage._user_data_language;
    }
    if (localStorage._user_data_sso_token) {
      params.sso_token = localStorage._user_data_sso_token;
      params.client_version = "1.2.0";
    }
    // params.sys_id = '5'
    // params.sys_id = localStorage._sys_id || '5'
    if (localStorage._sys_id) params.sys_id = localStorage._sys_id;

    return axios({
      method: "get",
      url: url,
      params: params,
      withCredentials: true,
    })
      .then(checkStatus)
      .then(checkCode);
  },
  delete(url, params) {
    if (localStorage._user_data_id) params.user_id = localStorage._user_data_id;
    if (localStorage._user_data_department_id)
      params.department_id = localStorage._user_data_department_id;
    if (localStorage._user_data_company_id)
      params.company_id = localStorage._user_data_company_id;
    if (localStorage._user_data_language) {
      params.language = localStorage._user_data_language;
    }
    if (localStorage._user_data_sso_token) {
      params.sso_token = localStorage._user_data_sso_token;
      params.client_version = "1.2.0";
    }
    if (localStorage._sys_id) params.sys_id = localStorage._sys_id;

    return axios({
      method: "delete",
      url: url,
      params: params,
      withCredentials: true,
    })
      .then(checkStatus)
      .then(checkCode);
  },
};
